import { FCX, Tooltip, getFormattedThousand } from "@datassential/platform-ui-lib";
import { IconInfoStokes } from "@icons";
import { HEAT_SCORES_SORTED, HEAT_SCORE_DESCRIPTION } from "@core/heatScores";
import { MAC_STAGE_DESCRIPTION, MAC_STAGES } from "@core/macStages";
import StageList from "@components/new/LabeledList/LabeledList";
import { EMPTY_CELL_VALUE } from "@pages/Home/constants";

interface FormattedNumberProps {
    value?: number | null;
}

interface PercentageWithSignProps {
    value?: number | null;
}

interface TooltipHeaderProps {
    title: string;
    tooltipContent: React.ReactNode;
    tooltipId?: string;
}

export const FormattedNumber: FCX<FormattedNumberProps> = ({ value }) => (
    <>{value ? getFormattedThousand(value) : EMPTY_CELL_VALUE}</>
);

export const PercentageCell: FCX<PercentageWithSignProps> = ({ value }) => (
    <>{value && isFinite(value) ? `${value.toFixed(1)}%` : EMPTY_CELL_VALUE}</>
);

export const PercentageWithSign: FCX<PercentageWithSignProps> = ({ value }) => (
    <>{value && isFinite(value) ? `${value > 0 ? '+' : ''}${getFormattedThousand(Math.round(value))}%` : EMPTY_CELL_VALUE}</>
);

const TooltipHeader: FCX<TooltipHeaderProps> = ({ 
    title, 
    tooltipContent, 
    tooltipId 
}) => {
    const id = tooltipId || `tooltip-${title.toLowerCase().replace(/\s+/g, '-')}`;
    
    return (
        <div className="HomeTrendingTable__tooltip">
            <span className="HomeTrendingTable__title">{title}</span>
            <IconInfoStokes
                width={12}
                height={12}
                data-tooltip-id={id}
            />
            <Tooltip id={id} place="top" style={{ zIndex: 10, maxWidth: '365px', padding: '12px 12px 20px' }}>
                {tooltipContent}
            </Tooltip>
        </div>
    );
};

export const MacStageTooltipHeader: FCX = () => (
    <TooltipHeader
        title="MAC Stage"
        tooltipContent={
            <StageList
                items={MAC_STAGES}
                type="macStages"
                title={MAC_STAGE_DESCRIPTION}
            />
        }
    />
);

export const HeatScoreTooltipHeader: FCX = () => (
    <TooltipHeader
        title="Heat Score"
        tooltipContent={
            <StageList
                items={HEAT_SCORES_SORTED}
                type="heatScores"
                title={HEAT_SCORE_DESCRIPTION}
            />
        }
    />
);